import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'

const Overlay = ({ children, className, service, ...props }) =>
  <Wrapper className={ className } service={ service } { ...props }>
    <Modal service={ service }>
      { children }
    </Modal>
  </Wrapper>

Overlay.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string,
  service: PropTypes.Boolean
}

export default Overlay

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  text-align: center;
  background-color: ${Theme.colors.transparent_overlay};
  ${Mixin.middle()}
  ${Media.mobile`
    padding: 20px;
  `}
  ${props => props.service && css`
    ${Media.mobile`
      position: relative;
    `}
  `}
`

const Modal = styled.div`
  display: inline-block;
  vertical-align: middle;
  background-color: ${Theme.colors.white};
  border: 1px solid ${Theme.colors.light_grey};
  ${Mixin.responsive('width', '480px', '100%')}
  ${Mixin.responsive('padding', '25px 20px', '20px')}
  ${props => props.service && css`
    ${Mixin.responsive('padding', '16px 20px', '16px 20px 6px 20px')}
  `}
`
